export default __webpack_public_path__ + "bbe7d2ddece40f95e18a85dfc85a8feb.png";